import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('notificationUserSettings', app)
  return store
}
